export { default } from './text-input-mask';
